import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { SolutionModel } from '@app/src/app/modules/solution/classes/default/model/solution.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class SolutionsPublicRequestQuery extends AbstractGraphqlRequest<
  SolutionModel[]
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findPublicSolutions($payload: SolutionRequestPayloadInput) {
        findPublicSolutions(payload: $payload) {
          category {
            title
            slug
            data {
              leftColor
              rightColor
            }
          }
          cover {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          picture {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          slug
          title
          description
          shortDescription
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    const items = data.findPublicSolutions || [];

    return items.map((item: any) => new SolutionModel(item));
  }
}
